/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Type de membre dans l\'organisation
 */
export const typeMemberSchema = z.enum(["ADMIN", "MEMBER", "INVALIDATED", "INVITED", "CANCELLED"]).describe("Type de membre dans l'organisation")